<div class="flex-container" [nbSpinner]="(loading$|async)!!">
  <wr-repair-task-status-icon [status]="repairTask().status"></wr-repair-task-status-icon>
  <div class="left-column">
    <div class="title">{{getCheckpointNumber(repairTask().inspectionEntryCheckpoint)}}
      {{ repairTask().inspectionEntryCheckpoint?.name }}</div>
    <div class="section">{{ repairTask().buildingSection?.sectionText }}</div>
    @if (repairTask().deadline; as deadline) {
      <div class="deadline">Frist: {{ deadline | date: 'dd.MM.yyyy' }}</div>
    }
  </div>
  <div class="right-column">
    <wr-repair-task-status-text [status]="repairTask().status"></wr-repair-task-status-text>
    @if (showDeleteButton() && canEdit()) {
      <button nbButton
              status="danger"
              ghost
              nbTooltip="Löschen"
              nbTooltipStatus="danger"
              (click)="showDeleteDialog($event)">
        <nb-icon pack="eva" icon="trash-2-outline"></nb-icon>
      </button>
    }
    @if (showConfirmButton() && canFinish()) {
      <button nbButton
              status="success"
              nbTooltip="Bestätigen"
              nbTooltipStatus="success"
              (click)="setStatusFinished($event)">
        <nb-icon pack="eva" icon="checkmark-outline"></nb-icon>
      </button>
    }
  </div>
</div>

@if (showDescription()) {
  <div class="description">{{ repairTask().description }}</div>
}
